import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq, getUrlParams} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function messagesCloseNewDropdown() {
  return {
    type: constants.MESSAGES_CLOSE_NEW,
  };
}

export function messagesOpenNewDropdown(recipient = null) {
  return {
    type: constants.MESSAGES_OPEN_NEW,
    recipient
  };
}

export function messagesOpenNewDiamondDropdown(diamonds) {
  return {
    type: constants.MESSAGES_OPEN_NEW_DIAMOND,
    diamonds
  };
}

export function messagesSave(messages) {
  return {
    type: constants.MESSAGES_SAVE,
    messages
  };
}

export function messagesDeletedSave(messages) {
	return {
    type: constants.MESSAGES_DELETED_SAVE,
    messages
  };
}

export function messagesSaveSent(messages) {
  return {
    type: constants.MESSAGES_SAVE_SENT,
    messages
  };
}

export function messagesSaveDirectory(users) {
	return {
    type: constants.MESSAGES_SAVE_DIRECTORY,
    users
  };
}

export function messagesShowConfirmation(messageText = null) {
	return {
    type: constants.MESSAGES_SHOW_CONFIRMATION,
    messageText
  };
}

export function messagesHideConfirmation() {
	return {
    type: constants.MESSAGES_HIDE_CONFIRMATION,
  };
}


/******************************
*******  Asynchronous  ********
******************************/




export function fetchUserMessages() {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchDeletedUserMessages() {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_DELETED_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchSentUserMessages() {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SENT;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messageSendSimple(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SEND_SIMPLE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messageSendShare(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SEND_SHARE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function recordMessageRead(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_RECORD_READ;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesDeleteMessage(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_DELETE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesSendHoldReq(holdData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SEND_HOLD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(holdData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function messagesSendTransferReq(transferData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SEND_TRANSFER;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transferData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesSendTransferLoc50Req(transferData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_SEND_TRANSFER_LOC50;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transferData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesApproveTransfer(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_APPROVE_TRANSFER;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function messagesRejectTransfer(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_REJECT_TRANSFER;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesApproveHold(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_APPROVE_HOLD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function messagesRejectHold(messageData) {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_REJECT_HOLD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(messageData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function deleteAllMessagesAction() {

	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_DELETE_ALL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify({})
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function messagesFetchMyTransfers(getData, signal = null) {
	
	return dispatch => {

		let url = api.API_URL + endpoint.MESSAGES_TRANSFERS_MINE + getUrlParams(getData);
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		  signal,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}
















